export type HomeHuntPlacement = { viewKey: string; top: string; left: string };

export const HOME_HUNT_PLACEMENTS: Record<string, HomeHuntPlacement> = {
  "v2-home-calendar-upper-left": { viewKey: "Home:main", top: "18%", left: "9%" },
  "v2-home-weather-middle-right": { viewKey: "Home:main", top: "58%", left: "86%" },
  "v2-calendar-month-upper-left": { viewKey: "Calendar:month", top: "24%", left: "18%" },
  "v2-calendar-month-middle-right": { viewKey: "Calendar:month", top: "57%", left: "82%" },
  "v2-lists-shopping-middle-left": { viewKey: "Lists:shopping", top: "52%", left: "7%" },
  "v2-lists-house-lower-right": { viewKey: "Lists:house", top: "78%", left: "90%" },
  "v2-family-book-middle-right": { viewKey: "Family Book:main", top: "48%", left: "86%" },
  "v2-finances-goals-upper-right": { viewKey: "Finances:goals", top: "23%", left: "90%" },
  "v2-finances-networth-middle-left": { viewKey: "Finances:networth", top: "52%", left: "6%" },
  "v2-expenses-charts-middle-right": { viewKey: "Expenses:charts", top: "48%", left: "91%" },
  "v2-expenses-completed-lower-left": { viewKey: "Expenses:completed", top: "76%", left: "6%" },
  "v2-income-summary-lower-left": { viewKey: "Income:summary", top: "74%", left: "7%" },
  "v2-income-review-middle-right": { viewKey: "Income:review", top: "48%", left: "90%" },
  "v2-investments-today-middle-left": { viewKey: "Investments:today", top: "48%", left: "6%" },
  "v2-investments-week-middle-right": { viewKey: "Investments:week", top: "52%", left: "90%" },
  "v2-investments-wl-upper-right": { viewKey: "Investments:wl", top: "24%", left: "90%" },
  "v2-investments-activity-lower-left": { viewKey: "Investments:activity", top: "76%", left: "7%" }
};
